// 589 Labs Admin Portal — Dark Navy & Gold design tokens
// All admin views (Dashboard, Leads, Customers, Sidebar) use this palette.
// The Customer Portal is intentionally on a separate "Light Executive Clarity" theme.

export const ADMIN_TOKENS = {
  // Backgrounds
  navy: "#0B1628",
  navyDeep: "#0B1628",
  navySurface: "#152038",
  navyHover: "#1a2842",

  // Brand accents
  gold: "#C79A3B",
  goldSoft: "#E5BD63",
  goldGlow: "rgba(199, 154, 59, 0.15)",

  // Functional colors
  success: "#16a34a",
  successSoft: "#22c55e",
  warning: "#f59e0b",
  warningSoft: "#fbbf24",
  danger: "#dc2626",
  dangerSoft: "#ef4444",
  info: "#3b82f6",

  // Content area
  contentBg: "#f4f6fa",
  cardBorder: "#e5e7eb",
  textPrimary: "#0f172a",
  textSecondary: "#475569",
  textMuted: "#94a3b8",
};

// Helpers — currency
export const fmtUSD = (n, opts = {}) => {
  const num = Number(n) || 0;
  const fmt = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: opts.decimals ?? 0,
    minimumFractionDigits: opts.decimals ?? 0,
  });
  return fmt.format(num);
};

export const fmtUSDCompact = (n) => {
  const num = Number(n) || 0;
  if (num >= 1000) return `$${(num / 1000).toFixed(num % 1000 === 0 ? 0 : 1)}K`;
  return `$${num.toLocaleString()}`;
};

export const fmtRelativeDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const now = new Date();
    const diffMs = now - d;
    const diffH = Math.round(diffMs / (1000 * 60 * 60));
    if (diffH < 1) return "Just now";
    if (diffH < 24) return `${diffH}h ago`;
    const diffD = Math.round(diffH / 24);
    if (diffD === 1) return "Yesterday";
    if (diffD < 7) return `${diffD}d ago`;
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  } catch {
    return "—";
  }
};

export const fmtAddedOn = (iso) => {
  if (!iso) return "—";
  try {
    return `Added ${new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`;
  } catch {
    return "—";
  }
};

export const fmtCustomerSince = (iso) => {
  if (!iso) return "—";
  try {
    return `Customer since ${new Date(iso).toLocaleDateString("en-US", { month: "short", year: "numeric" })}`;
  } catch {
    return "—";
  }
};

// Last-login key — used for "Since you last logged in" briefing
export const LAST_LOGIN_KEY = "589labs:admin:lastLoginAt";

export const getPreviousLoginAt = () => {
  try {
    return localStorage.getItem(LAST_LOGIN_KEY) || null;
  } catch {
    return null;
  }
};

export const stampLastLogin = () => {
  try {
    localStorage.setItem(LAST_LOGIN_KEY, new Date().toISOString());
  } catch {
    // ignore
  }
};
